module.exports = __webpack_public_path__ + "images/leistungen/saubere_filme_leistungen_video_strategie_mobile.jpg";